// @ts-strict-ignore
import { ArticleNumberMappingVO } from '@article/model/vo/article-number-mapping.vo';

export class ArticleNumberMappingUtils {
  public static findMappingByArticleNumber(articleNumber: string, mappings: ArticleNumberMappingVO[]): ArticleNumberMappingVO {
    if (!articleNumber || !mappings || !mappings.length) {
      return;
    }
    return mappings
      .find((numberMapping: ArticleNumberMappingVO) => numberMapping.articleNumber.trim() === articleNumber.trim());
  }

  public static isEqualMappings(mappingA: ArticleNumberMappingVO, mappingB: ArticleNumberMappingVO): boolean {
    if (!mappingA && !mappingB) {
      return true;
    }
    if (!mappingA || !mappingB) {
      return false;
    }
    return mappingA.articleNumber.trim() === mappingB.articleNumber.trim() &&
      mappingA.customArticleNumber.trim() === mappingB.customArticleNumber.trim();
  }
}
